module.exports = __webpack_public_path__ + "static/img/passxt.a1cea3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/passxt.png
// module id = Y1S1
// module chunks = 0